import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

import { newsDetailRequestCompleted } from '../actions';
import { getNewsDetailKey } from '../utils';

const { takeEvery, put } = sagaEffects;

function* handler({ payload, meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    const collection = meta.delayed ? config.collections.newsDelayed : config.collections.news;

    try {
        for (const lang of config.app.languages) {
            yield firestore.get({
                collection: `languages/${lang}/${collection}`,
                doc: `${payload.id}`,
                storeAs: getNewsDetailKey(collection, payload.id, lang),
            });
        }
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.news.detail' }));
    } finally {
        yield put(newsDetailRequestCompleted());
    }
}
export default function* () {
    yield takeEvery(types.NEWS_DETAIL_REQUEST, handler);
}
